import React from 'react';
import { womenCalculators } from './ConstantsWomenCalculator';
import SharedHelmet from '.././Helmet'
const TITLE = 'حواسب النساء - حواسب مجانية للصحة النسائية والحمل والدورة الشهرية';
const DESCRIPTION = 'استكشف مجموعة حواسب النساء المجانية، بما في ذلك حواسب الدورة الشهرية والحمل وتقدير تواريخ مهمة في صحة النساء.';
const KEYWORDS = 'حواسب النساء، حواسب مجانية، حاسبة الدورة الشهرية، حاسبة الحمل، تواريخ صحة النساء';
const OG_URL = 'https://do-calculate.com/ar/women-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {womenCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
